module.exports = __webpack_public_path__ + "static/media/referrals.034546e8.jpg";